<template>
  <div class="box text-center">
    <img :src="warn" alt="" class="w-[50px] h-[55px] m-auto" />
    <div class="title">{{ $t('goldenFlower.showdown') }}</div>
    <div class="text">{{ $t('goldenFlower.text1') }}</div>
    <img :src="bg" alt="" class="h-[100px] m-auto" />
    <ButtonThe3DButton class="flex-1" color="blue" @click="emits('reCompare')">{{ $t('goldenFlower.Reselect') }}</ButtonThe3DButton>
  </div>
</template>

<script setup lang='ts'>
import warn from '../img/warn.webp';
import bg from '../img/icon.webp';

const emits = defineEmits(['reCompare']);
</script>

<style scoped lang='scss'>
.box {
  z-index: 2;
  position: absolute;
  width: 70%;
  max-width: 360px;
  min-height: 260px;
  background: linear-gradient(0deg, #101B27, #101B27),
    radial-gradient(42.96% 42.96% at 50% 0%, rgba(246, 146, 32, 0.2) 0%, rgba(255, 223, 166, 0) 100%);
  border: 1px solid #FF7F00;
  border-radius: 12px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 32px 0px #E5B55D99 inset;
  padding: 16px;
}
.title {
  color: #F6DA87;
  font-weight: 600;
  font-size: 18px;
  margin: 4px 0;
}
.text {
  line-height: 18px;
  color: #E2E2E2;
}
</style>